// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { SessionProtocol } from "./session-protocol";
import { SshOptions, SshOptionsT, verifySshOptions } from "./ssh-options";
import { TelnetOptions, TelnetOptionsT, verifyTelnetOptions } from "./telnet-options";

/**
 * A channel's session settings. Nothing here is secret.
 */
export class SessionConfig implements flatbuffers.IUnpackableObject<SessionConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SessionConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSessionConfig(bb: flatbuffers.ByteBuffer, obj?: SessionConfig): SessionConfig {
    return (obj || new SessionConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSessionConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: SessionConfig,
  ): SessionConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SessionConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  protocol(): SessionProtocol {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SessionProtocol.None;
  }

  /**
   * Login name for telnet or SSH. Empty with telnet means the device asks for
   * no login, so only the ready marker is awaited.
   */
  username(): string | null;
  username(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  username(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  telnet(obj?: TelnetOptions): TelnetOptions | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new TelnetOptions()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  ssh(obj?: SshOptions): SshOptions | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new SshOptions()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startSessionConfig(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addProtocol(builder: flatbuffers.Builder, protocol: SessionProtocol) {
    builder.addFieldInt8(0, protocol, SessionProtocol.None);
  }

  static addUsername(builder: flatbuffers.Builder, usernameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, usernameOffset, 0);
  }

  static addTelnet(builder: flatbuffers.Builder, telnetOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, telnetOffset, 0);
  }

  static addSsh(builder: flatbuffers.Builder, sshOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, sshOffset, 0);
  }

  static endSessionConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): SessionConfigT {
    return new SessionConfigT(
      this.protocol(),
      this.username(),
      this.telnet() !== null ? this.telnet()!.unpack() : null,
      this.ssh() !== null ? this.ssh()!.unpack() : null,
    );
  }

  unpackTo(_o: SessionConfigT): void {
    _o.protocol = this.protocol();
    _o.username = this.username();
    _o.telnet = this.telnet() !== null ? this.telnet()!.unpack() : null;
    _o.ssh = this.ssh() !== null ? this.ssh()!.unpack() : null;
  }

  unpackFields(...fields: string[]): SessionConfigT {
    const t = new SessionConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("protocol")) {
      t.protocol = this.protocol();
    }
    if (fieldSet.has("username")) {
      t.username = this.username();
    }
    if (fieldSet.has("telnet")) {
      t.telnet = this.telnet() !== null ? this.telnet()!.unpack() : null;
    }
    if (fieldSet.has("ssh")) {
      t.ssh = this.ssh() !== null ? this.ssh()!.unpack() : null;
    }
    return t;
  }
}

export class SessionConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public protocol: SessionProtocol = SessionProtocol.None,
    public username: string | Uint8Array | null = null,
    public telnet: TelnetOptionsT | null = null,
    public ssh: SshOptionsT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const username = this.username !== null ? builder.createString(this.username!) : 0;
    const telnet = this.telnet !== null ? this.telnet!.pack(builder) : 0;
    const ssh = this.ssh !== null ? this.ssh!.pack(builder) : 0;

    SessionConfig.startSessionConfig(builder);
    SessionConfig.addProtocol(builder, this.protocol);
    SessionConfig.addUsername(builder, username);
    SessionConfig.addTelnet(builder, telnet);
    SessionConfig.addSsh(builder, ssh);

    return SessionConfig.endSessionConfig(builder);
  }

  clone(): SessionConfigT {
    const obj = new SessionConfigT();
    obj.protocol = this.protocol;
    obj.username = this.username;
    obj.telnet = this.telnet !== null ? this.telnet!.clone() : null;
    obj.ssh = this.ssh !== null ? this.ssh!.clone() : null;
    return obj;
  }

  equals(other: SessionConfigT): boolean {
    if (this.protocol !== other.protocol) return false;
    if (this.username !== other.username) return false;
    if (this.telnet !== null && other.telnet !== null) {
      if (!this.telnet!.equals(other.telnet!)) return false;
    } else if (this.telnet !== other.telnet) return false;
    if (this.ssh !== null && other.ssh !== null) {
      if (!this.ssh!.equals(other.ssh!)) return false;
    } else if (this.ssh !== other.ssh) return false;
    return true;
  }
}

export function verifySessionConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyTelnetOptions(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifySshOptions(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
